import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface PromotionStateParameter extends ApiParameter {
    showPromotionErrorMessage: boolean;
    promotionErrorMessage?: string;
    removedPromoCode?: string;
}

export interface PromotionStateResult {
}

type HandlerType = CustomApiHandler<PromotionStateParameter, PromotionStateResult>;

export const DispatchPromotionState: HandlerType = props => {
    props.dispatch({
        type: "Custom/Checkout/ShowPromotionErrorMessage",
        showPromotionErrorMessage: props.parameter.showPromotionErrorMessage,
        promotionErrorMessage: props.parameter.promotionErrorMessage ? props.parameter.promotionErrorMessage: "",
        removedPromoCode: props.parameter.removedPromoCode ? props.parameter.removedPromoCode: "",
    });
};

export const chain = [DispatchPromotionState];

const setPromotionState = createHandlerChainRunner(chain, "setPromotionState");
export default setPromotionState;


//showPromotionMessage: boolean, promotionErrorMessage: string, removedPromoCode: string 